/* global $:true dataLayer:true */
/**
 * Facebook Feed Block
 *
 *  For more Facebook plugin options see https://developers.facebook.com/docs/plugins/page-plugin
 *
 */

import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '.fb-page';
const MODULE_NAME = 'app.core/modules/facebook-feed-block';
const log = debug(MODULE_NAME);
const ZERO = 0;
const SCRIPT = '<script defer="true"> \
    (function (d, s, id) { \
        var js, fjs = d.getElementsByTagName(s)[0]; \
        if (d.getElementById(id)) return; \
        js = d.createElement(s); \
        js.id = id; \
        js.src = "//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v2.12"; \
        fjs.parentNode.insertBefore(js, fjs); \
    }(document, "script", "facebook-jssdk")); \
</script>';

class FacebookFeedBlock {

    constructor (element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$scriptContainer = $(this.options.scriptContainer);

        log('FacebookFeedBlock', element);

        this.loadScript();

        log('ready', this.$element);
    }

    loadScript () {
        if (typeof(this.$scriptContainer) !== 'undefined') {
            if (this.$scriptContainer.find('script').length == 0) {
                this.$scriptContainer.html(SCRIPT);
            }
        }
    }
}

FacebookFeedBlock.DEFAULTS = {
    scriptContainer: '.facebook-feed-block-scripts'
};

plugin('facebookFeedBlock', FacebookFeedBlock);

export function exec () {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).facebookFeedBlock();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/facebook-feed-block/index.js